import React from "react";
import CardStyle from "../../css/coupon.module.scss";

import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@mui/system";

function Qwick_silver_available(props) {
  const vht = useSelector((state) => state.qwickSilver);

  return (
    <>
      <Stack spacing={2}>
        <Stack spacing={1} direction='row'>
          <Typography>Amount Left</Typography>
          <Typography color='primary' >{vht?.data?.response?.qwik_blance || "--"}</Typography>
        </Stack>
        <Stack spacing={1} direction='row'>
          <Typography >Last Coupon Order Price</Typography>
          <Typography color='primary'>{vht?.data?.response?.last_qwik_order_price || "--"}</Typography>
        </Stack>
        <Stack spacing={1} direction='row'>
          <Typography>Last Coupon Order</Typography>
          <Typography color='primary'>{vht?.data?.response?.last_qwik_order_at || "--"}</Typography>
        </Stack>
      </Stack>
    </>
  );
}

export default Qwick_silver_available;
